import { render, staticRenderFns } from "./KPIMenu.vue?vue&type=template&id=73de0afe&"
import script from "./KPIMenu.vue?vue&type=script&lang=js&"
export * from "./KPIMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports